import { Injectable, OnDestroy } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Customer } from '@df/session/api/customer';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { Nexus } from '@tomandco/nexus-api-types';
import sum from 'lodash-es/sum';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NInformationCentreComponent } from './account-information-centre.component';

declare module '@df/session/customer/customer.interfaces' {
    namespace Customer {
        interface ICustomerData {
            last_visited_message_board_date?: string;
        }
    }
}

@Injectable()
export class AccountInformationCentreService implements OnDestroy {
    private readonly subscriptions = new Subscription();
    private saveCustomerPath = Nexus.Api.Customer.Save.path;
    readonly numberOfUnreadMessages = new BehaviorSubject<number | undefined>(undefined);

    constructor(private iCmsBlockResource: ICmsBlockResource, private customer: Customer, private requestService: RequestService) {
        this.setupTracking();
    }

    private setupTracking(): void {
        this.assignNotificationNumber();
        this.subscriptions.add(
            this.customer.model.obs.data.subscribe(() => {
                this.assignNotificationNumber();
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    private async assignNotificationNumber(): Promise<void> {
        const currentDate = new Date();
        const informationCentreComponentData = await this.iCmsBlockResource.retrieve({ bareUrl: NInformationCentreComponent.componentId }, undefined);
        const lastVisitedMessageBoardDate = this.customer.model.data?.last_visited_message_board_date;
        if (informationCentreComponentData && lastVisitedMessageBoardDate) {
            const number = sum(
                (informationCentreComponentData as ICmsBlock)!.data!.content!.items.map(el => {
                    const lastVisitedMessageBoardDateFormatted = new Date(this.customer.model.data!.last_visited_message_board_date!);
                    return el.links.filter(el => {
                        const elementDate = new Date(el.date);
                        return elementDate > lastVisitedMessageBoardDateFormatted && elementDate <= currentDate;
                    }).length;
                })
            );
            this.numberOfUnreadMessages.next(number);
        } else {
            this.numberOfUnreadMessages.next(undefined);
        }
    }

    resetCutsomerLastVisitedMessageBoardDate(): void {
        const newCustomerData = this.customer.model.data;
        const currentDate = new Date();
        newCustomerData.last_visited_message_board_date = currentDate.toISOString();
        this.requestService.send(undefined, { path: this.saveCustomerPath, data: newCustomerData });
    }
}
